import React from 'react';
import { ChevronLeft, ChevronRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface StepNavigationFooterProps {
  onBack?: () => void;
  onSkip?: () => void;
  onContinue: () => void;
  continueLabel?: string;
  skipLabel?: string;
  isLoading?: boolean;
  isContinueDisabled?: boolean;
  isBackDisabled?: boolean;
  isSkipDisabled?: boolean;
  className?: string;
}

export const StepNavigationFooter: React.FC<StepNavigationFooterProps> = ({
  onBack,
  onSkip,
  onContinue,
  continueLabel = 'Continue',
  skipLabel = 'Skip for now',
  isLoading = false,
  isContinueDisabled = false,
  isBackDisabled = false,
  isSkipDisabled = false,
  className,
}) => {
  return (
    <div className={cn('flex items-center justify-between border-t pt-8', className)}>
      {onBack ? (
        <Button
          variant="outline"
          size="lg"
          onClick={onBack}
          disabled={isBackDisabled}
          className="min-w-[120px]"
        >
          <ChevronLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
      ) : (
        <span aria-hidden="true" />
      )}
      <div className="flex items-center gap-3">
        {onSkip ? (
          <Button variant="ghost" onClick={onSkip} disabled={isSkipDisabled || isLoading}>
            {skipLabel}
          </Button>
        ) : null}
        <Button
          size="lg"
          onClick={onContinue}
          disabled={isContinueDisabled || isLoading}
          className="min-w-[160px] gap-2"
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              {continueLabel}
              <ChevronRight className="h-4 w-4" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
